import { Component, h, Prop } from '@stencil/core';
import { Option } from '@hpfc/fc-frontend-core';

/**
 * Surrounds an `fccd-checkbox-list` with a collapsible filter panel.
 */
@Component({
  tag: 'fccd-facet-checkbox-list',
  styleUrl: 'facet-checkbox-list.scss',
})
export class FacetCheckboxList {
  /**
   * The id for the element in this component.
   */
  @Prop() elementId!: string;
  /**
   * 'true' we should hide the optional label for the checkboxes, 'false' otherwise.
   */
  @Prop() hideInputOptionalLabel: boolean = true;
  /**
   * Optional message for the checkbox list fieldset.
   */
  @Prop() listLabel?: string;
  /**
   * The Options to display
   */
  @Prop() options: string | Array<Option>;
  /**
   * The header text.
   */
  @Prop() panelLabel: string;
  /**
   * 'true' if the field is required, 'false' otherwise.
   */
  @Prop() required?: boolean = false;

  private getPanelName(): string {
    return 'panel-' + this.elementId;
  }

  render() {
    return (
      <hp5-filter-panel filter-panel-label={this.panelLabel} label-tag-selection="h3" element-id={this.getPanelName()}>
        <fccd-checkbox-list
          componentName={this.elementId}
          hideInputOptionalLabel={this.hideInputOptionalLabel}
          label={this.listLabel}
          options={this.options}
          required={this.required}
        />
      </hp5-filter-panel>
    );
  }
}
